__turbopack_context__.v({
  "background": "EventHero-module-scss-module__DiaJba__background",
  "hero": "EventHero-module-scss-module__DiaJba__hero",
  "root": "EventHero-module-scss-module__DiaJba__root",
});
